export enum FormFieldType {
  Text = 'text',
  Number = 'number',
  Select = 'select',
  Tel = 'tel',
}
